<template>
    <div class="card mb-25 border-0 rounded-0 bg-white todays-course-box" v-if="surveys === undefined">
        <div class="card-body p-15 p-sm-20 p-sm-25 pt-lg-30 pb-lg-30 ps-lg-25 pe-lg-25">
            <SpinnerLoading class="h-auto" />
        </div>
    </div>
    <div class="row" v-else v-for="(surveys, name, index) in survey_groups" :key="`group:${name}`">
        <div class="col-12 " v-if="name !== ''">
            <template v-if="env === 'kareena'">
                <div class="mb-25 p-15 ps-lg-25 pe-lg-25 border-bottom border-2">
                    <h5 class="fw-medium text-white mb-0">{{ titlecase(name.toString()) }}</h5>
                </div>
            </template>
            <template v-else>
                <div
                    class="mb-25 card border-0 shadow z-1 rounded-0 bg-white p-15 p-sm-25 ps-lg-25 pe-lg-25 fw-bold fs-12 text-muted">
                    <h5 class="fw-medium text-black-emphasis mb-0">{{ titlecase(name.toString()) }}</h5>
                </div>
            </template>
        </div>
        <div class="col-12 mb-25" v-for="survey in surveys" :key="survey.id">
            <SurveyCard :survey="survey" :patient_id="patient.id!" @priority="checkSurveyPriority" />
        </div>
        <div class="mb-15" v-if="index !== Object.keys(survey_groups).length - 1"></div>
    </div>

</template>
<script lang="ts">
import API from '@/services/api/api.service';
import { Survey } from '@/utils/models/survey.model';
import { PatientInfo } from '@/utils/models/user.model';
import DateFormatUtils from "@/utils/methods/date_formats";
import { defineComponent } from 'vue';
import SpinnerLoading from "@/components/Widgets/Spinner.vue";
import config, { Environment } from '@/utils/const/config';
import { CLIENT } from '@/utils/const/env';
import SurveyCard from './SurveyCard.vue';

export default defineComponent({
    name: 'SurveyCardsList',
    data: function () {
        return {
            surveys: undefined,
            show_detail: false,
        } as {
            surveys?: Survey[] | null;
            show_detail: boolean
        }
    },
    methods: {
        formatTime(date: Date) {
            return DateFormatUtils.HHmm(date);
        },
        titlecase(text: string) {
            return `${text.slice(0, 1).toUpperCase()}${text.slice(1)}`
        },
        checkSurveyPriority() {
            API.getSurveysPriority({ patient_Id: this.patient.id, per_page: 20, load_steps: false }).then((response) => {
                let surveysRes = response.data.success == true && response.data.data.length !== 0 ? response.data.data : null;
                if (this.env === 'kareena') {
                    surveysRes = surveysRes?.filter((survey) => survey.key !== 'kareena-questionario-iniziale')
                    // priority first sort
                    surveysRes = [
                        ...surveysRes!.filter(({ has_override_settings }) => has_override_settings),
                        ...surveysRes!.filter(({ has_override_settings }) => !has_override_settings),
                    ];
                    this.surveys = surveysRes;
                } else {
                    this.surveys = surveysRes;
                }
            })
        }
    },
    mounted() {
        this.checkSurveyPriority();
    },
    computed: {
        patient() { return this.$route.meta.patient as PatientInfo },
        env(): Environment { return CLIENT },
        survey_groups(): { [key: string]: Survey[] } {
            return ((this.surveys ?? []) as Survey[]).reduce((acc, cur) => {
                const key = cur.extra?.group ?? '';
                return { ...acc, [key]: [...(acc[key] || []), cur] };
            }, {} as { [key: string]: Survey[] });
        },
    },
    components: {
        SpinnerLoading,
        SurveyCard
    }
})
</script>

<style scooped>
.survey-card i {
    font-size: 23px;
}
</style>
